import { memo } from "react";

import { removeVS16s } from "~/utils/strings/removeVS16s";
import toCodePoint from "~/utils/strings/toCodePoint";

import ImageWithFallback from "../ImageWithFallback";

export interface Props {
  native: string;
  lazy?: boolean;
  title?: string;
  size?: number | string;
  className?: string;
}

const NEXT_PUBLIC_EMOJI_PATH = process.env.NEXT_PUBLIC_EMOJI_PATH;

const getPathToEmoji = (native: string): string => {
  const normalizedNative = removeVS16s(native);

  const UTF16SurrogatePairs = toCodePoint(normalizedNative);

  return `${NEXT_PUBLIC_EMOJI_PATH}${UTF16SurrogatePairs}.svg`;
};

const Emoji = memo(
  ({ native, size = "1em", title, lazy, className }: Props): JSX.Element => (
    <ImageWithFallback
      className={className}
      loading={lazy ? "lazy" : undefined}
      title={title}
      alt={native}
      src={getPathToEmoji(native)}
      fallbackElement={<span>{native}</span>}
      width={size}
      height={size}
    />
  )
);

Emoji.displayName = "Emoji";

export default Emoji;
